import * as React from 'react';
import { apiGeneral as api } from 'services/api'

export const useSendLoginInfo = () => {
  const [loading, setLoading] = React.useState(false);

  const sendLoginInfo = React.useCallback(async (userId: number) => {
    try {
      setLoading(true);
      await api.post('/users/send-login-info', { userId });
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    sendLoginInfo,
    loading,
  }
};
